<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel w-90pc active">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ panelHeader }}</h2>
            </div>            
            <div class="panel-left-btn">
                <div *ngIf="gridData.length > 0">
                    <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnViewMileageMapAndCalculations()" *ngIf="!isNotMileageCategory">
                        {{ 'view_map_calculation' | translate }}
                    </button>
                </div>
                <button type="button" class="btn eod-btn-outline-warning mr-2" *ngIf="gridData.length > 0 && gridData.length < legsCount" [ngClass]="{'disabled': gridData && gridData.length >= legsCount}"
                    (click)="fnShowAddJourneyPanel()">
                    {{ 'add_journey' | translate }}
                </button>
				<button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{'disabled': disableSaveButton || !hasFormChanges}"
                    (click)="fnSaveMultiplLegDetails()">
                    {{ 'save_text' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ "label_close" | translate }}
                </button>
            </div>
        </header>
        <div class="block mt-2 padding-top-10 " *ngIf="gridData.length == 0">
            <div class="col-md-12 no-padding-right-left margin-top-0 position-relative heightCalc-11 scrollbar-visible overflow-auto">
                <div class="">
                    <button class="btn btn-primary align-center-middle" [ngClass]="{'disabled-state': gridData.length == legsCount}" (click)="fnShowAddJourneyPanel()">
                        {{ 'add_journey' | translate }}
                        <span class="d-block">({{gridData.length}} / {{ legsCount }}) </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="block" [hidden]="!(gridData && gridData.length >0)">
            <div class="col-lg-12 no-padding-right-left ">
                <div class="row d-flex justify-content-between">
        
                    <p class="w-100pc d-flex justify-content-between fw-600 border-bottom padding-bottom-10 ">
                        <span class="fw-600 color-orange">{{ 'multiple_legs_list' | translate }}</span>
                        <span *ngIf="!isCarbonFootprintReporting">{{ 'total_legs' | translate }}:&nbsp; {{gridData.length}} | {{ 'total_distance' | translate }}: 
                            {{this.fnGetTotalDistanceOflegs()}} {{mileageUOMText}} </span>
                        <span *ngIf="isCarbonFootprintReporting">{{ 'total_legs' | translate }}:&nbsp; {{gridData.length}} | {{ 'total_distance' | translate }}: 
                                {{this.fnGetTotalDistanceOflegs()}} {{mileageUOMText}} | {{ 'carbon_emission' | translate }}: {{this.fnGetTotalCarbonEmission()}} {{carbonEmissionText}} </span>
                    </p>
    
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-12">
                <!----------------------Start Grid--------------------------->
                <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems" 
                (onCellClick)="fnOnGridCellClick($event)"
               >
                </app-grid>
                <!----------------------End Grid--------------------------->
            </div>
        </div>
    </div>
</div>

<!----------------------Side Panels--------------------------->

<add-journey-panel *ngIf="showAddJourneyPanel" [(inputModel)]="addJourneyInputModel"
 [(mileageAllowance)]="mileageAllowance" [(resourceMileageDetails)]="resourceMileageDetails" 
  [(vehicleResponse)]="vehicleResponse" [(expenseModel)]="expenseModel" [isCarbonFootprintReporting]="isCarbonFootprintReporting"
 (closePanelEvent)="fnCloseAddJourneyPanel($event)" (submitEvent)="fnSubmitAddJourneyPanel($event)" 
 (deleteEvent)="fnDeleteAddJourneyPanel($event)">
</add-journey-panel>

<app-alert-panel *ngIf="showDeleteConfirmationAlert" [data]="deleteConfirmationAlertModel"
    (callbackEvent)="fnDeleteConfirmationAlertReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showOneAddJourneyAlert" [data]="oneAddJourneyAlertModel"
    (callbackEvent)="fnOneAddJourneyAlertReceiver($event)">
</app-alert-panel>


<app-view-receipt #viewReceiptComponent [milesTravelled]="milesTravelled" [triangulationMiles]="triangulationMiles"
    [detourMiles]="detourMiles" [amount]="receiptAmount" [distance]="distance" [mileageRate]="mileageRate" [mileageArray]="mileageArray" 
    showDeleteButton=true [mileage]="calculateMileageDetails?.mileageDetailList[0]" [isMileageCategory]="isMileageCategory">
</app-view-receipt>

<app-alert-panel *ngIf="showGoogleServiceErrorPopup" [data]="GoogleServiceErrorPopupModel"
(callbackEvent)="fnGoogleServiceErrorPopupReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showChargingTypeActivationAlert" [data]="chargingTypeActivationAlertModel"
    (callbackEvent)="fnChargingTypeActivationAlertReceiver($event)">
</app-alert-panel>

<app-alert-panel *ngIf="showPassengerLoadVehicleNotMappedAlert" [data]="passengerLoadVehicleNotMappedAlertModel"
    (callbackEvent)="fnPassengerLoadVehicleNotMappedAlertReceiver($event)">
</app-alert-panel>